import React from 'react';
import './PackageCard.css';
import { useNavigate } from 'react-router-dom';

const PackageCard = ({
  title,
  topDetails = '',
  membershipTitle = '',
  membershipDesc = '',
  whatsIncluded = 'What’s Included',
  features = [],
  audience = '',
  cta = 'Contact Us',
  ctaLink = '/contact',
  icon,
  iconBg = '#0096D6',
  gradient = 'linear-gradient(120deg, #0076b6 0%, #0096D6 100%)',
  titleBg = '#ffa600',
  membershipDescColor = '#333',
}) => {
  const navigate = useNavigate();
  const handleCtaClick = () => {
    navigate('/contact');
  };
  return (
    <div className="package-card-v3">
      <div className="package-card-v3-icon-outer">
        <div className="package-card-v3-icon" style={{ background: iconBg }}>
          {icon}
        </div>
        <div className="package-card-v3-title" style={{ background: titleBg }}>{title}</div>
      </div>
      <div className="package-card-v3-gradient" style={{ background: gradient }}>
        <div className="package-card-v3-details">{topDetails}</div>
      </div>
      <div className="package-card-v3-body">
        <div className="package-card-v3-membership">
          <div className="package-card-v3-membership-title">{membershipTitle}</div>
          <div className="package-card-v3-membership-desc" style={{ color: membershipDescColor }}>{membershipDesc}</div>
        </div>
        <button className="package-card-v3-included-btn" tabIndex={-1}>{whatsIncluded}</button>
        <ul className="package-card-v3-features">
          {features.map((f, i) => (
            <li key={i}><span className="package-card-v3-check">✔</span>{f}</li>
          ))}
        </ul>
        <div className="package-card-v3-audience">{audience}</div>
        <button className="package-card-v3-cta" onClick={handleCtaClick}>{cta}</button>
      </div>
    </div>
  );
};

export default PackageCard;